import { Type } from 'class-transformer';
import { CalendarExportContants } from '@therealmanage/ciranet-ui-common';
import { CalendarEvent } from './calendar-event';

export class CalendarInstance {
  prodid: string;
  @Type(() => CalendarEvent)
  events: CalendarEvent[];

  constructor(prodid: string) {
    this.prodid = prodid;
    this.events = [];
  }

  addEvent(event: CalendarEvent): void {
    this.events.push(event);
  }

  addEvents(events: CalendarEvent[]): void {
    this.events.push(...events);
  }

  toCalendarString(): string {
    const items: string[] = [];

    items.push(CalendarExportContants.BEGIN_VCAL);
    items.push(CalendarExportContants.VERSION);
    items.push(CalendarExportContants.CALSCALE);
    items.push(CalendarExportContants.PRODID(this.prodid));
    items.push(CalendarExportContants.METHOD);
    items.push(CalendarExportContants.PUBLISHED);
    items.push(...this.events.map((event) => event.toEventString()));
    items.push(CalendarExportContants.END_VCAL);

    return items.join(CalendarExportContants.NEW_LINE);
  }
}
